// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-order-La7ARW{background:var(--light-color-brand-brand-5,#4d53e8);width:16px;height:16px;color:var(--light-color-white-white,#fff);border-radius:50%;justify-content:center;align-items:center;margin-top:2px;font-size:10px;font-weight:600;display:flex}.step-title-vWRtVL{color:#000;margin-bottom:8px;font-size:14px;font-weight:600;line-height:22px}.markdown-qLZ0zo{color:var(--light-usage-text-color-text-0,#1d1c23);font-size:14px;line-height:22px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step-order": `step-order-La7ARW`,
	"stepOrder": `step-order-La7ARW`,
	"step-title": `step-title-vWRtVL`,
	"stepTitle": `step-title-vWRtVL`,
	"markdown": `markdown-qLZ0zo`
};
export default ___CSS_LOADER_EXPORT___;
